import { render } from "./FreeText.vue?vue&type=template&id=437244c8"
import script from "./FreeText.vue?vue&type=script&lang=js"
export * from "./FreeText.vue?vue&type=script&lang=js"

import "./FreeText.vue?vue&type=style&index=0&id=437244c8&lang=css"

import exportComponent from "C:\\Server-Testumgebung\\way-academy-app-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__